export default {
  /*
    use this namespace to translate composable short phrases
    e.g.
    create_x: 'Create {{x}}',
  */
  add_x: 'Add {{x}}',
  approve_x: 'Approve {{x}}',
  bulk_upload_x: 'Bulk Upload {{x}}',
  cancel_x: 'Cancel {{x}}',
  change_x: 'Change {{x}}',
  check_list_of_x: 'Check list of {{x}}',
  choose_x: 'Choose {{x}}',
  date_by_actor: '{{date}}, by {{actor}}',
  day_add_x: 'D + {{x}}',
  days_left_before_x_is_expired: 'days left before {{x}} is expired',
  deactivate_x: 'Deactivate {{x}}',
  dialog_confirmation_content_x: 'Are you sure you want to {{x}}? This action cannot be undone',
  download_x: 'Download {{x}}',
  dropoff_n_log: 'Drop-off {{n}} Log',
  duplicate_x: 'Duplicate {{x}}',
  edit_x: 'Edit {{x}}',
  enter_x: 'Enter {{x}}',
  every_days: 'Every {{days}}',
  form_error_message: {
    mandatory: '{{field}} is mandatory',
    required: 'Insert {{field}}',
    invalid_format: 'Insert valid {{field}}',
    min_length: 'Minimum length for {{field}} is {{min}}',
    max_length: 'Maximum length for {{field}} is {{max}}',
    max_value: '{{field}} must be less than {{max}}',
    min_value: '{{field}} must be greater than {{min}}',
    num_with_max_decimal_value: '{{field}} must be a number with maximum of {{fraction}} decimal value',
    number_with_decimals: 'Use 0 or positive number with up to 8 decimal points here.',
    strong_password_rule:
      '{{field}} should at least have one uppercase, one lowercase, one number and one special character',
    document_is_required: 'This document has to be uploaded.',
    field_already_exist: '{{ field }} already exist',
  },
  hide_x: 'Hide {{x}}',
  hold_x: 'Hold {{x}}',
  info_pagination: 'Showing {{number}} of {{total}} {{field}}',
  input_x: 'Input {{x}}',
  input_x_id: 'Input {{x}} ID',
  invalid_datetime_format_x: 'Invalid Datetime Format: {{x}}. Datetime should be {{dateFormat}}',
  invalid_x: 'Invalid {{x}}',
  last_updated_x: 'Last Updated {{x}}',
  log_message: {
    by_actor_at_time: 'by {{actor}}, at {{time}}',
    dropoff_n_shipment_edited: 'Drop-off {{n}} edited',
    dropoff_n_status_updated_to_x: 'Drop-off {{n}} status updated to {{x}}',
    status_updated_to_x: 'Status updated to {{x}}',
    updated_to_x: 'Updated to {{x}}',
  },
  mark_x_as_y: 'Mark {{x}} as {{y}}',
  x_must_be_in: '{{x}} must be in {{dateFormat}} format',
  n_x_selected: '{{n}} {{x}} has been selected',
  pagination_indicator: 'Page {{page}} from {{total}}',
  replacement_x: 'Replacement {{x}}',
  review_x: 'Review {{x}}',
  reviewed_by_x: 'Reviewed by {{x}}',
  save_x: 'Save {{x}}',
  search_x: 'Search {{x}}',
  select_x: 'Select {{x}}',
  show_x: 'Show {{x}}',
  total_x: 'Total {{x}}',
  type_x: 'Type {{x}}',
  update_x: 'Update {{x}}',
  upload_x: 'Upload {{x}}',
  unfulfill_x: 'Unfulfill {{x}}',
  view_x: 'View {{x}}',
  x_boolean_value_should_be: '{{x}} should only be TRUE or FALSE',
  x_code: '{{x}} Code',
  x_days: '{{x}} Days',
  x_details: '{{x}} Details',
  x_end_date: '{{x}} End Date',
  x_expiration_date: '{{x}} Expiration Date',
  x_id: '{{x}} ID',
  x_if_any: '{{x}} (if any)',
  x_is_already_expired: '{{x}} is already expired',
  x_is_required: '{{x}} is required',
  x_must_be_empty: '{{x}} Must be Empty',
  x_name: '{{x}} Name',
  x_need_revision: '{{x}}_need revision',
  x_need_to_update_existing_data: '{{x}} needed to update existing data',
  x_number: '{{x}} Number',
  x_number_value_should_be: '{{x}} should be number',
  x_price: '{{x}} Price',
  x_successfully_y: '{{x}} successfully {{y}}',
  x_to_download: 'Select {{x}} to download',
  x_type: '{{x}} Type',
  x_uploaded_on_y_by_z: '{{x}} uploaded on {{y}} by {{z}}',
  you_can_only_upload_to_update_for_x: 'You can only upload to update for {{x}}',
};
